import { Menu as MenuAntd } from 'antd';
import styled from 'styled-components';
import color from '../../configs/color';
import thumbStyle from '../../configs/thumbStyle';

const Menu = styled(MenuAntd)`
  background-color: ${color.grey5};
  width: ${(props) => {
    return props.width ? `${props.width}` : '404px';
  }};
  max-width: ${(props) => {
    return props.max || 'unset';
  }};
  max-height: ${(props) => {
    return props.height || 'unset';
  }};
  ${thumbStyle};
  overflow-y: auto;
  padding: 12px;
  border-radius: 12px;
  .component_dropdown_list_item_title {
    white-space: normal;
    color: ${color.black2};
  }
  .component_dropdown_list_item_desc {
    white-space: normal;
    color: ${color.black4};
  }

  .ant-dropdown-menu-item {
    padding: 8px;
    border-radius: 8px;
    :hover {
      background-color: ${color.grey3};
    }
  }

  .component_dropdown_list_item {
    display: grid;
    grid-template-columns: auto 1fr;
  }

  display: grid;
  gap: ${(props) => {
    return props.gap ? `${props.gap}px` : '16px';
  }};
`;

export default Menu;
